<template>
  <div class="user-profile compact text-left" v-if="user">
    <div class="up-head-w" style="background-image:url(img/profile_bg1.jpg)">
      <div class="up-social">
        <a href="#"><i class="os-icon os-icon-twitter"></i></a><a href="#"><i class="os-icon os-icon-facebook"></i></a>
      </div>
      <div class="up-main-info">
        <h2 class="up-header">
          {{ user.firstName }} {{ user.middleName }} {{ user.lastName }} @{{ user.username }} ({{ user.balance | toMoney(user.currency) }})
        </h2>
        <h6 class="up-sub-header">
          {{ user.group.name }}
        </h6>
      </div>
      <svg class="decor" width="842px" height="219px" viewBox="0 0 842 219" preserveAspectRatio="xMaxYMax meet" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g transform="translate(-381.000000, -362.000000)" fill="#FFFFFF"><path class="decor-path" d="M1223,362 L1223,581 L381,581 C868.912802,575.666667 1149.57947,502.666667 1223,362 Z"></path></g></svg>
    </div>
      <div class="up-controls">
        <div class="row">
          <div class="col-sm-12 text-right">
            <div class="value-pair pull-left">
              <div class="label">
                {{ t.last_activity }}:
              </div>
              <div class="value badge badge-pill" v-tooltip="dateTimeFormat(user.lastActivityAt)">
                {{ user.lastActivityAt | timeAgo }}
              </div>
            </div>
            <router-link :to="{name: 'users', params: {id: user.id}, query: {view: 'balance'} }" class="btn btn-primary btn-sm" href=""><i class="os-icon os-icon-dollar-sign"></i><span>{{ t.user.add_balance }}</span></router-link>
            <router-link :to="{name: 'users', params: {id: user.id}, query: {view: 'promotions'} }" class="btn btn-danger btn-sm" href=""><i class="os-icon os-icon-award"></i><span>{{ t.user.add_bonus }}</span></router-link>
          </div>
          <div class="col-sm-12">
            <div class="value-pair">
              <div class="label">
                {{ t.betting.title.status }}:
              </div>
              <div class="value badge badge-pill badge-success" v-if="user.isActiveNow">
                {{ t.user.online }}
              </div>
            </div>
            <div class="value-pair">
              <div class="label">
                {{ t.user.last_login }}:
              </div>
              <div class="value badge badge-pill" v-tooltip="dateTimeFormat(user.lastLogin)">
                {{ user.lastLogin | timeAgo }}
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="up-contents">
      <div class="m-b">
        <div class="row m-b">
          <div class="col-sm-6 b-r b-b">
            <div class="el-tablo centered padded-v">
              <div class="value">
                {{ user.payment | toMoney(user.currency) }}
              </div>
              <div class="label">
                {{ t.navigation.deposit_transactions }}
              </div>
            </div>
          </div>
          <div class="col-sm-6 b-b">
            <div class="el-tablo centered padded-v">
              <div class="value">
                {{ user.withdraw | toMoney(user.currency) }}
              </div>
              <div class="label">
                {{ this.$root.t.navigation.withdraw_transactions }}
              </div>
            </div>
          </div>
        </div>
        <div class="padded">
          <div class="row">
            <div class="col-sm-12">
              <div class="listy b-b">
										<span class="label">
											Risk Template
										</span>
                <select v-model="user.risk" @change="changeUserTemplate()" class="form-control">
                  <option value="0">System Default</option>
                  <option v-for="c in templates" :value="c.id">{{ c.name }}</option>
                </select>
              </div>
            </div>
            <div class="col-sm-12">
              <div class="listy b-b">
										<span class="label">
											Notes
										</span>
                {{ user.note }}
              </div>
            </div>
          </div>
        </div>
    <template v-if="more">
          <div class="padded">
            <div class="row">
              <div class="col-sm-12">
                <div class="listy b-b">
										<span class="label">
											{{ t.user.username }}
										</span>
                  {{ user.username }}
                </div>
                <div class="listy b-b">
										<span class="label">
											{{ t.user.full_name }}
										</span>
                  {{ user.firstName }} {{ user.middleName }} {{ user.lastName }}
                </div>
                <div class="listy b-b">
										<span class="label">
											{{ t.user.date_of_brith }}
										</span>
                  {{ user.dateOfBirth | moment(session.date_format, session.timezone) }}
                </div>
                <div class="listy b-b">
										<span class="label">
											{{ t.user.age }}
										</span>
                  {{ user.age }}
                </div>
                <div class="listy b-b">
										<span class="label">
											{{ t.user.region }}
										</span>
                  {{ user.region.name }}
                </div>
                <div class="listy b-b">
										<span class="label">
											{{ t.user.status }}
										</span>
                  <span v-if="user.enabled">
											{{ t.user.enabled }}
										</span>
                  <span v-else>
										{{ t.user.disabled }}
										</span>
                  <span v-if="user.deleted" class="badge badge-pill badge-danger">
											{{ t.user.deleted }}
										</span>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="listy b-b">
										<span class="label">
											{{ t.user.mobile_phone }}
										</span>
                  <span v-if="user.mobilePhone">
											+{{ user.mobilePhone.country_code }} {{ user.mobilePhone.national_number }}
										</span>
                </div>
                <div class="listy b-b">
										<span class="label">
											{{ t.finance.currency }}
										</span>
                  {{ user.currency.iso_code }}
                </div>
                <div class="listy b-b">
										<span class="label">
											{{ t.user.balance }}
										</span>
                  {{ user.balance | toMoney(user.currency) }}
                </div>
                <div class="listy b-b">
										<span class="label">
											{{ t.user.credit }}
										</span>
                  {{ user.credit | toMoney(user.currency) }}
                </div>
                <div class="listy b-b">
										<span class="label">
											{{ t.user.bonus }}
										</span>
                  {{ user.bonus | toMoney(user.currency) }}
                </div>

                <div class="listy b-b">
										<span class="label">
											{{ t.user.email }}
										</span>
                  {{ user.email }}
                </div>
              </div>
              <div class="col-sm-12">
                <div class="listy b-b">
										<span class="label">
											{{ t.user.home_address }}
										</span>
                  {{ user.homeAddress }}
                </div>
                <div class="listy b-b">
										<span class="label">
											Social Number
										</span>
                  {{ user.idendifierNo }}
                </div>
                <div class="listy b-b">
										<span class="label">
											{{ t.affiliate.code }}
										</span>
                  {{ user.ref }}
                </div>
              </div>
            </div>
          </div>
    </template>
      </div>
      <a href="javascript:void(0);" @click="showMore" class="btn btn-block btn-outline-info">{{ t.show_more }}</a>
    </div>

  </div>
</template>

<script>
    import Feed from '@/mixins/feed';
    export default {
        name: 'userCard',
        props: ['id'],
        mixins: [Feed],
        data () {
            return {
                more: false,
                session: window.session,
                t: this.$root.t,
                user: null,
                templates: []
            }
        },
        mounted () {
            this.fetchUser(this.id);

            this.fetchTemplates(2).then((d) => {
              this.templates = d.body;
            })
        },
        methods: {
            changeUserTemplate (tid) {
              this.setUserRiskTemplate(this.id, this.user.risk)
            },
            showMore () {
                this.more = (!this.more) ? true : false;
            },
            fetchUser (uid) {
                this.$http.get(api+'api/v1/users?uid='+uid,
                    { params: this.$route.query })
                    .then(response => {
                        this.pagination = response.body.result.pagination;
                        this.user = response.body.result.users[0];
                    }, response => {
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/profile/card.vue